import { FC, useEffect, useRef, useState } from 'react'
import { Button, ButtonGroup, Card, Col, Dropdown, DropdownButton, Form, ListGroup, Modal, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import DTOOpViajes from '../../../DTOs/Operaciones/DTOViajes'
import DSOpViajes from '../../../Services/Operaciones/OpViajes.Services'
import { updateOpViajes } from '../../../store/features/Operaciones/OpViajesSlice'
import { RootState } from '../../../store/store'
import {
  populateOpViajesServicios,
  updateOpViajesServicios,
} from '../../../store/features/Operaciones/OpViajesServiciosSlice'
import DTOViajesServicios from '../../../DTOs/Operaciones/DTOViajesServicios'
import { Servicios } from '../Viaje/Servicios/Servicios'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css'
import '../../../css/autoComplete.css'
import { IconContext } from 'react-icons'
import { FaCaretSquareDown, FaCaretSquareLeft } from 'react-icons/fa'

interface IProps {
  IDViaje: number
}

interface IOpciones {
  value: string
  label: string
}

export const Viaje: FC<IProps> = (props) => {
  const [selectedOption, setselectedOption] = useState<IOpciones | null>()
  const dispatch = useDispatch()
  const mAllTrips = useSelector((state: RootState) => state.OpViajes.OpViajes)
  const mAllTripServices = useSelector((state: RootState) => state.OpViajesServicios.OpViajesServicios)
  const Info = JSON.parse(localStorage.getItem('tokenInfo') || '[]')
  const UserID = Info.UserId
  const mCatClientes = useSelector((state: RootState) => state.CatClientes.CatClientes)
  const mCatProveedores = useSelector((state: RootState) => state.CatProveedores.CatProveedores)
  const CatTipoUnidades = useSelector((state: RootState) => state.CatTipoUnidades.CatTipoUnidades)
  const mCatUbicaciones = useSelector((state: RootState) => state.CatUbicaciones.CatUbicaciones)
  const mCatServicios = useSelector((state: RootState) => state.CatServicios.CatServicios)
  const CatAduanas = useSelector((state: RootState) => state.CatAduanas.CatAduanas)
  const [NoCaja, setNoCaja] = useState('')
  const [UltimaCaja, setUltimaCaja] = useState('')
  const [IDViaje, setIDViaje] = useState(0)
  const [IDDetail, setIDDetail] = useState(0)
  const [IDCliente, setIDCliente] = useState(0)
  const [Cliente, setCliente] = useState('')
  const [IDProveedor, setIDProveedor] = useState(0)
  const [Proveedor, setProveedor] = useState('')
  const [IDServicio, setIDServicio] = useState(0)
  const [Servicio, setServicio] = useState('')
  const [IDTipoUnidad, setIDTipoUnidad] = useState(0)
  const [IDOrigen, setIDOrigen] = useState(0)
  const [Origen, setOrigen] = useState('')
  const [IDDestino, setIDDestino] = useState(0)
  const [Destino, setDestino] = useState('')
  const [RefAA, setRefAA] = useState('')
  const [PickUpNumber, setPickUpNumber] = useState('')
  const [Hazmat, setHazmat] = useState(0)
  const [Pedimento, setPedimento] = useState('')
  const [TipoOperacion, setTipoOperacion] = useState(1)
  const [Comentarios, setComentarios] = useState('')
  const [Aduana, setAduana] = useState(0)
  const [DisableAduana, setDisableAduana] = useState(true)
  const [TotalServicios, setTotalServicios] = useState(0)
  const [Cita, setCita] = useState<Date | null>()
  const [SelectedClient, setSelectedClient] = useState(false)
  const [SelectedOrigen, setSelectedOrigen] = useState(false)
  const [SelectedDestino, setSelectedDestino] = useState(false)
  const [SelectedServicio, setSelectedServicio] = useState(false)
  const [SelectedProveedor, setSelectedProveedor] = useState(false)
  const inputRef = useRef()

  useEffect(() => {
    if (IDServicio > 0 && TotalServicios === 0) saveDetail()
    let selectedRow = mAllTrips.filter((row) => {
      if (row.id === props.IDViaje) {
        setIDViaje(row.id)
        setRefAA(row.refAgenciaAduanal)
        setIDCliente(row.cliente)
        setIDTipoUnidad(row.tipoUnidad)
        setNoCaja(row.noCaja)
        setIDOrigen(row.origen)
        setIDDestino(row.destino)
        setHazmat(row.hazmat)
        setPickUpNumber(row.pickUpNumber)
        setTipoOperacion(row.tipoOperacion)
        setPedimento(row.pedimento)
        setCliente(row.sCliente)
        setOrigen(row.sOrigen)
        setDestino(row.sDestino)
        setSelectedClient(true)
        setSelectedOrigen(true)
        setSelectedDestino(true)
        setSelectedServicio(true)
        setSelectedProveedor(true)
        return row
      }
    })
    let totalServicios = mAllTripServices.filter((a) => {
      if (a.idViaje === IDViaje) {
        return a
      }
    })
    setTotalServicios(totalServicios.length)
  }, [IDViaje])

  useEffect(() => {
    if (IDServicio === 1 || IDServicio === 2 || IDServicio === 22) setDisableAduana(false)
    else setDisableAduana(true)
    if (IDServicio > 0) {
      let serviceFound = mCatServicios.filter((item) => {
        if (item.id == IDServicio) {
          return item
        }
      })
      setServicio(serviceFound[0].servicio)
    }
    if (IDProveedor > 0) {
      let providerFound = mCatProveedores.filter((item) => {
        if (item.id == IDProveedor) {
          return item
        }
      })
      setProveedor(providerFound[0].proveedor)
    }
  }, [IDServicio])

  useEffect(() => {
    DSOpViajes.GetLastTrailerBox(IDViaje)
      .then((response) => {
        const LastTrailerBox = response.data.ultimaCaja
        //  console.log('lasttrailerbox=' + LastTrailerBox)
        if (LastTrailerBox.length === 0) setUltimaCaja(NoCaja)
        else setUltimaCaja(LastTrailerBox)
      })
      .catch((e: Error) => {
        //  console.log('currio un error')
      })
    //console.log('nocaja=' + NoCaja)
  }, [NoCaja])

  useEffect(() => {
    if (IDViaje === 0) {
      setSelectedClient(true)
      setSelectedOrigen(true)
      setSelectedDestino(true)
      setSelectedServicio(true)
      setSelectedProveedor(true)
    }
  }, [])

  useEffect(() => {
    if (Hazmat === 1) setAduana(180)
    else setAduana(0)
  }, [Hazmat])

  const saveDetail = () => {
    if (IDServicio === 0 || IDProveedor === 0) {
      return false
    }
    const data: DTOViajesServicios = {
      id: IDDetail,
      idViaje: IDViaje,
      idServicio: IDServicio,
      sServicio: '',
      cita: Cita ? adjustTimeZone(Cita.toISOString()) : '',
      aduana: Aduana,
      comentarios: Comentarios,
      idProveedor: IDProveedor,
      sProveedor: '',
      noCaja: UltimaCaja,
    }
    DSOpViajes.AppendServices(data)
      .then((responsed) => {
        if (IDDetail === 0) {
          dispatch(populateOpViajesServicios(responsed.data))
          setIDDetail(responsed.data[0].id)
        } else {
          dispatch(updateOpViajesServicios(responsed.data))
        }
        clearDetailForm()
      })
      .catch((e: Error) => {})
  }

  const adjustTimeZone = (str: string): string => {
    if (str) {
      const original: any = new Date(str)
      const real = new Date(original - original.getTimezoneOffset() * 60 * 1000)
      return real.toISOString()
    } else return ''
  }

  const loadService = (id: number) => {
    let found = mAllTripServices.filter((a) => {
      if (a.id === id) {
        return a
      }
    })
    if (found) {
      setIDDetail(id)
      setAduana(found[0].aduana)
      setIDServicio(found[0].idServicio)
      setComentarios(found[0].comentarios)
      setIDProveedor(found[0].idProveedor)
      // setUltimaCaja(found[0].noCaja)
    }
  }

  const saveMaster = () => {
    if (TotalServicios === 0) {
      if (IDServicio === 0) {
        alert('Para continuar, primero seleccione un servicio ')
        return false
      }
      if (IDProveedor === 0) {
        alert('Para continuar, primero seleccione un proveedor')
        return false
      }
    }
    /*      */
    const data: DTOOpViajes = {
      id: IDViaje,
      fAlta: '',
      usuario: UserID,
      refAgenciaAduanal: RefAA,
      cliente: IDCliente,
      sCliente: '',
      tipoUnidad: IDTipoUnidad,
      sTipoUnidad: '',
      origen: IDOrigen,
      sOrigen: '',
      destino: IDDestino,
      sDestino: '',
      hazmat: Hazmat,
      noCaja: NoCaja,
      pickUpNumber: PickUpNumber,
      tipoOperacion: TipoOperacion,
      sTipoOperacion: '',
      pedimento: Pedimento,
      max: true,
      status: 1,
    }
    DSOpViajes.Append(data)
      .then((response) => {
        const data = response.data
        data['max'] = false
        dispatch(updateOpViajes(data))
        setIDViaje(data.id)
      })
      .catch((e: Error) => {})
  }

  const clearDetailForm = () => {
    setIDDetail(0)
    setAduana(0)
    setIDServicio(0)
    setComentarios('')
    setIDProveedor(0)
    setUltimaCaja('')
    setServicio('')
    setProveedor('')
    setDisableAduana(true)
  }

  useEffect(() => {
    console.log(selectedOption)
  }, [selectedOption])

  const handleKeyDown = (e: any) => {
    //  const { cursor, result } = this.state
    // arrow up/down button should select next/previous list element
    /*  if (e.keyCode === 38) {
      console.log('arrow down')
      
    } else */
    if (e.keyCode === 40) {
      console.log('arrow down')
    }
  }

  return (
    <div className='tripField'>
      <Card style={{ backgroundColor: '#F0F7FC' }}>
        <Card.Body>
          <Row>
            <Col xs={2}>No viaje</Col>
            <Col xs={2}>
              <Form.Control type='text' id='IDViaje' value={IDViaje} disabled size='sm' className='dialogLabel' />
            </Col>
            <Col xs={2} style={{ textAlign: 'right' }}>
              Ref AA
            </Col>
            <Col xs={3}>
              <Form.Control
                type='text'
                id='RefAA'
                value={RefAA}
                size='sm'
                className='dialogLabel'
                onChange={(e) => {
                  setRefAA(e.target.value)
                }}
              />
            </Col>
            <Col xs={3} style={{ textAlign: 'right' }}></Col>
          </Row>
          <Row style={{ paddingTop: '5px' }}>
            <Col xs={2}>Cliente</Col>
            <Col xs={8} style={{ paddingRight: '0px' }}>
              <div className='mainDiv'>
                <Form.Group className='typeahead-form-group'>
                  <Form.Control
                    autoComplete='off'
                    type='text'
                    id='Cliente'
                    value={Cliente}
                    size='sm'
                    className='pull-right'
                    onChange={(e) => {
                      setCliente(e.target.value)
                      setSelectedClient(false)
                    }}
                    onKeyDown={(e) => {
                      handleKeyDown(e)
                    }}
                  />
                  <Dropdown className='d-inline mx-6' show={!SelectedClient}>
                    <Dropdown.Menu>
                      {mCatClientes
                        .filter((result) => result.cliente.toLocaleLowerCase().includes(Cliente.toLocaleLowerCase()))
                        .map((result) => (
                          <Dropdown.Item
                            onClick={() => {
                              setIDCliente(result.id)
                              setCliente(result.cliente)
                              setSelectedClient(true)
                            }}
                          >
                            {result.cliente}
                          </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
              </div>
            </Col>
            <Col style={{ paddingLeft: '0px' }}>
              <div onClick={() => setSelectedClient(!SelectedClient)}>
                {!SelectedClient ? (
                  <IconContext.Provider value={{ color: '#8AA2B8', size: '30px' }}>
                    <FaCaretSquareDown />
                  </IconContext.Provider>
                ) : (
                  <IconContext.Provider value={{ color: '#8AA2B8', size: '30px' }}>
                    <FaCaretSquareLeft />
                  </IconContext.Provider>
                )}{' '}
              </div>
            </Col>
          </Row>
          <Row style={{ paddingTop: '5px' }}>
            <Col xs={2}>Tipo Unidad</Col>
            <Col xs={3}>
              <Form.Control
                as='select'
                onChange={(e) => {
                  setIDTipoUnidad(parseInt(e.target.value))
                }}
                value={IDTipoUnidad}
                className='form-select form-select-sm dialogLabel'
              >
                <option value='0'>-SELECCIONE-</option>
                {CatTipoUnidades
                  ? CatTipoUnidades.map((c) => {
                      return (
                        <option key={c.id} value={c.id}>
                          {c.tipoUnidad}
                        </option>
                      )
                    })
                  : null}
              </Form.Control>
            </Col>
            <Col xs={1} style={{ textAlign: 'right' }}>
              Caja
            </Col>
            <Col xs={3}>
              <Form.Control
                type='text'
                id='NoCaja'
                value={NoCaja}
                size='sm'
                className='dialogLabel'
                onChange={(e) => {
                  setNoCaja(e.target.value)
                }}
              />
            </Col>
          </Row>
          <Row style={{ paddingTop: '5px' }}>
            <Col xs={2}>Origen</Col>
            <Col xs={3} style={{ paddingRight: '0px' }}>
              <div className='mainDiv'>
                <Form.Group className='typeahead-form-group1'>
                  <Form.Control
                    autoComplete='off'
                    type='text'
                    id='Origen'
                    value={Origen}
                    size='sm'
                    className='textBoxViaje'
                    onChange={(e) => {
                      setOrigen(e.target.value)
                      setSelectedOrigen(false)
                    }}
                  />
                  <Dropdown className='d-inline mx-6' show={!SelectedOrigen}>
                    <Dropdown.Menu>
                      {mCatUbicaciones
                        .filter(
                          (result) =>
                            result.ubicacion.toLocaleLowerCase().includes(Origen.toLocaleLowerCase()) &&
                            result.clasificacion === 1
                        )
                        .map((result) => (
                          <Dropdown.Item
                            onClick={() => {
                              setIDOrigen(result.id)
                              setOrigen(result.ubicacion)
                              setSelectedOrigen(true)
                            }}
                          >
                            {result.ubicacion}
                          </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
              </div>
            </Col>
            <Col style={{ paddingLeft: '0px' }}>
              <div onClick={() => setSelectedOrigen(!SelectedOrigen)}>
                {!SelectedOrigen ? (
                  <IconContext.Provider value={{ color: '#8AA2B8', size: '30px' }}>
                    <FaCaretSquareDown />
                  </IconContext.Provider>
                ) : (
                  <IconContext.Provider value={{ color: '#8AA2B8', size: '30px' }}>
                    <FaCaretSquareLeft />
                  </IconContext.Provider>
                )}{' '}
              </div>
            </Col>
            <Col xs={2} style={{ textAlign: 'right' }}>
              Destino
            </Col>
            <Col xs={3} style={{ paddingRight: '0px' }}>
              <div className='mainDiv'>
                <Form.Group className='typeahead-form-group2'>
                  <Form.Control
                    autoComplete='off'
                    type='text'
                    id='Destino'
                    value={Destino}
                    size='sm'
                    className='dialogLabel'
                    onChange={(e) => {
                      setDestino(e.target.value)
                      setSelectedDestino(false)
                    }}
                  />
                  <Dropdown className='d-inline mx-6' show={!SelectedDestino}>
                    <Dropdown.Menu>
                      {mCatUbicaciones
                        .filter(
                          (result) =>
                            result.ubicacion.toLocaleLowerCase().includes(Destino.toLocaleLowerCase()) &&
                            result.clasificacion === 2
                        )
                        .map((result) => (
                          <Dropdown.Item
                            onClick={() => {
                              setIDDestino(result.id)
                              setDestino(result.ubicacion)
                              setSelectedDestino(true)
                            }}
                          >
                            {result.ubicacion}
                          </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
              </div>
            </Col>
            <Col style={{ paddingLeft: '0px' }}>
              <div onClick={() => setSelectedDestino(!SelectedDestino)}>
                {!SelectedDestino ? (
                  <IconContext.Provider value={{ color: '#8AA2B8', size: '30px' }}>
                    <FaCaretSquareDown />
                  </IconContext.Provider>
                ) : (
                  <IconContext.Provider value={{ color: '#8AA2B8', size: '30px' }}>
                    <FaCaretSquareLeft />
                  </IconContext.Provider>
                )}{' '}
              </div>
            </Col>
          </Row>
          <Row style={{ paddingTop: '5px' }}>
            <Col xs={2}>HazMat</Col>
            <Col sx={1}>
              <Form.Control
                as='select'
                onChange={(e) => {
                  setHazmat(parseInt(e.target.value))
                }}
                value={Hazmat}
                className='form-select form-select-sm dialogLabel'
              >
                <option value='0'>No</option>
                <option value='1'>Si</option>
              </Form.Control>
            </Col>
            <Col xs={2} style={{ textAlign: 'right' }}>
              Tipo operacion
            </Col>
            <Col xs={3}>
              <Form.Control
                as='select'
                onChange={(e) => {
                  setTipoOperacion(parseInt(e.target.value))
                }}
                value={TipoOperacion}
                className='form-select form-select-sm dialogLabel'
              >
                <option value='1'>Importacion</option>
                <option value='2'>Exportacion</option>
                <option value='3'>Solo americano</option>
                <option value='4'>Solo mexicano</option>
              </Form.Control>
            </Col>
            <Col xs={3}>&nbsp;</Col>
          </Row>
          <Row style={{ paddingTop: '5px' }}>
            <Col xs={2}>Pedimento</Col>
            <Col xs={3}>
              <Form.Control
                type='text'
                id='Pedimento'
                value={Pedimento}
                size='sm'
                className='dialogLabel'
                onChange={(e) => {
                  setPedimento(e.target.value)
                }}
              />
            </Col>
            <Col xs={2}>PickUp No</Col>
            <Col xs={3}>
              <Form.Control
                type='text'
                id='PickUpNumber'
                value={PickUpNumber}
                size='sm'
                className='dialogLabel'
                onChange={(e) => {
                  setPickUpNumber(e.target.value)
                }}
              />
            </Col>
            <Col style={{ textAlign: 'right' }}></Col>
          </Row>
        </Card.Body>
      </Card>
      <Row style={{ paddingTop: '5px' }}>
        <Col xs={12}></Col>
      </Row>
      <Card style={{ backgroundColor: '#DDEFEF' }}>
        <Card.Body>
          <Row style={{ paddingTop: '5px' }}>
            <Col xs={2}>Servicio</Col>
            <Col xs={4} style={{ paddingRight: '0px' }}>
              <div className='mainDiv'>
                <Form.Group className='typeahead-form-3'>
                  <Form.Control
                    autoComplete='off'
                    type='text'
                    id='Servicio'
                    value={Servicio}
                    size='sm'
                    className='dialogLabel'
                    onChange={(e) => {
                      setServicio(e.target.value)
                      setSelectedServicio(false)
                    }}
                    onKeyDown={(e) => {
                      handleKeyDown(e)
                    }}
                  />
                  <Dropdown className='d-inline mx-6' show={!SelectedServicio}>
                    <Dropdown.Menu>
                      {mCatServicios
                        .filter((result) => result.servicio.toLocaleLowerCase().includes(Servicio.toLocaleLowerCase()))
                        .map((result) => (
                          <Dropdown.Item
                            onClick={() => {
                              setIDServicio(result.id)
                              setServicio(result.servicio)
                              setSelectedServicio(true)
                            }}
                          >
                            {result.servicio}
                          </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
              </div>
            </Col>
            <Col style={{ paddingLeft: '0px' }}>
              <div onClick={() => setSelectedServicio(!SelectedServicio)}>
                {!SelectedServicio ? (
                  <IconContext.Provider value={{ color: '#8AA2B8', size: '30px' }}>
                    <FaCaretSquareDown />
                  </IconContext.Provider>
                ) : (
                  <IconContext.Provider value={{ color: '#8AA2B8', size: '30px' }}>
                    <FaCaretSquareLeft />
                  </IconContext.Provider>
                )}
              </div>
            </Col>
            <Col xs={3} style={{ textAlign: 'center' }}>
              {/*  <Button
                variant='primary'
                onClick={() => {
                  saveMaster()
                  saveDetail()
                }}
              >
                Guardar
              </Button> */}
            </Col>
            <Col xs={2}></Col>
          </Row>
          <Row style={{ paddingTop: '5px' }}>
            <Col xs={2}>Proveedor</Col>
            <Col xs={9} style={{ paddingRight: '0px' }}>
              <div className='mainDiv'>
                <Form.Group className='typeahead-form-group4'>
                  <Form.Control
                    autoComplete='off'
                    type='text'
                    id='Proveedor'
                    value={Proveedor}
                    size='sm'
                    className='dialogLabel'
                    onChange={(e) => {
                      setProveedor(e.target.value)
                      setSelectedProveedor(false)
                    }}
                  />
                  <Dropdown className='d-inline mx-6' show={!SelectedProveedor}>
                    <Dropdown.Menu>
                      {mCatProveedores
                        .filter((result) =>
                          result.proveedor.toLocaleLowerCase().includes(Proveedor.toLocaleLowerCase())
                        )
                        .map((result) => (
                          <Dropdown.Item
                            onClick={() => {
                              setIDProveedor(result.id)
                              setProveedor(result.proveedor)
                              setSelectedProveedor(true)
                            }}
                          >
                            {result.proveedor}
                          </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
              </div>
            </Col>
            <Col style={{ paddingLeft: '0px' }}>
              <div onClick={() => setSelectedProveedor(!SelectedProveedor)}>
                {!SelectedProveedor ? (
                  <IconContext.Provider value={{ color: '#8AA2B8', size: '30px' }}>
                    <FaCaretSquareDown />
                  </IconContext.Provider>
                ) : (
                  <IconContext.Provider value={{ color: '#8AA2B8', size: '30px' }}>
                    <FaCaretSquareLeft />
                  </IconContext.Provider>
                )}{' '}
              </div>
            </Col>
          </Row>
          <Row style={{ paddingTop: '5px' }}>
            <Col xs={2}>Comentarios</Col>
            <Col xs={10}>
              <Form.Control
                as='textarea'
                rows={2}
                value={Comentarios}
                onChange={(e) => {
                  setComentarios(e.target.value)
                }}
              />
            </Col>
          </Row>
          <Row style={{ paddingTop: '5px' }}>
            <Col xs={2}>Caja</Col>
            <Col xs={3}>
              <Form.Control
                type='text'
                id='UltimeCaja'
                value={UltimaCaja}
                size='sm'
                className='dialogLabel'
                onChange={(e) => {
                  setUltimaCaja(e.target.value)
                }}
              />
            </Col>
            <Col style={{ visibility: DisableAduana ? 'hidden' : 'visible' }}>
              <DatePicker
                selected={Cita}
                onChange={(date: any) => setCita(date)}
                showTimeSelect
                dateFormat='MM/dd/yyyy HH:mm:ss'
                placeholderText='Cita no definida'
                isClearable
              />
            </Col>
            <Col xs={3}>
              <Form.Control
                as='select'
                onChange={(e) => {
                  setAduana(parseInt(e.target.value))
                }}
                value={Aduana}
                disabled={Hazmat === 1}
                className='form-select form-select-sm dialogLabel'
              >
                {CatAduanas
                  ? CatAduanas.map((c) => {
                      return (
                        <option key={c.id} value={c.id}>
                          {c.Aduana}
                        </option>
                      )
                    })
                  : null}
              </Form.Control>
            </Col>
          </Row>
          <Row style={{ paddingTop: '5px' }}>
            <Col xs={10}></Col>
            <Col xs={2}>
              <Button
                variant='primary'
                onClick={() => {
                  saveMaster()
                  saveDetail()
                }}
              >
                Guardar
              </Button>
            </Col>
          </Row>
        </Card.Body>
        <Card>
          <Card.Body>
            <div className='MDContainer'>
              <Servicios
                IDMaster={IDViaje}
                key={IDViaje}
                onLoadDetail={function (id: number): void {
                  loadService(id)
                }}
                actionButtons={true}
              />
            </div>
          </Card.Body>
        </Card>
      </Card>
    </div>
  )
}
